import { createReducer, on, Action } from '@ngrx/store';
import { UserModel } from '../models/user.model';
import * as fromActions from './login.actions';

export interface LoginState {
  isLoading: boolean;
  user: UserModel;
  success: any;
  errors: any;
}

export const initialState: LoginState = {
  isLoading: false,
  user: UserModel.empty(),
  success: null,
  errors: null,
};

const reducer = createReducer(
  initialState,
  // On Begin Actions
  on(
    fromActions.LoginBeginAction,
    fromActions.SocialLoginBeginAction,
    fromActions.LogoutBeginAction,
    (state): LoginState => ({
      ...state,
      errors: null,
      isLoading: true,
    })
  ),

  // ON Success Actions
  on(
    fromActions.LoginSuccessAction,
    fromActions.SocialLoginSuccessAction,
    (state, action): LoginState => ({
      ...state,
      isLoading: false,
      success: { after: 'USER_LOGIN_SUCCESS'},
      user: action.user,
    })
  ),
  on(
    fromActions.LogoutSuccessAction,
    (state): LoginState => ({ ...state, user: UserModel.empty() })
  ),

  on(
    fromActions.SetUserData,
    (state, action): LoginState => ({
      ...state,
      user: action.user,
    })
  ),

  // ON Fail Actions
  on(
    fromActions.LoginFailAction,
    fromActions.SocialLoginFailAction,
    fromActions.LogoutFailAction,
    (state, action): LoginState => ({
      isLoading: false,
      user: UserModel.empty(),
      success: { after: 'USER_LOGIN_ERROR'},
      errors: action.errors,
    })
  )
);

export const loginReducer = (state: LoginState | undefined, action: Action) =>
  reducer(state, action);
